/* Cart helpers (global, loaded by layout/theme.liquid).
   [data-adv-cart-add][data-variant-id]  adds one unit and re-renders the cart drawer (empty cart, upsell).
   [data-np-protect]                     the optional shipping-protection switch: adds the protection variant
                                         (/cart/add.js) or removes its line (/cart/change.js), then re-renders.
   cart-drawer.np-items-in               set for a moment when the drawer opens, so the line cards slide in once. */
(() => {
  const SECTIONS = 'cart-drawer,cart-icon-bubble';
  const ITEMS_IN_MS = 900;

  async function postJSON(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Cart request failed');
    return data;
  }

  function render(data) {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || !data.sections) return;
    drawer.classList.toggle('is-empty', data.item_count === 0);
    drawer.renderContents({ sections: data.sections });
  }

  function initCartAdds() {
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-adv-cart-add]');
      if (!btn) return;
      e.preventDefault();
      if (btn.disabled) return;
      btn.disabled = true;
      const label = btn.textContent;
      btn.textContent = 'Adding…';
      try {
        const data = await postJSON(`${window.routes.cart_add_url}.js`, {
          items: [{ id: Number(btn.dataset.variantId), quantity: 1 }],
          sections: SECTIONS,
        });
        const drawer = document.querySelector('cart-drawer');
        if (drawer && data.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ sections: data.sections });
        }
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'adv-upsell', cartData: data });
        }
      } catch (err) {
        console.error(err);
        btn.textContent = 'Try again';
        btn.disabled = false;
        return;
      }
      btn.textContent = label;
      btn.disabled = false;
    });
  }

  function initProtection() {
    document.addEventListener('click', async (e) => {
      const sw = e.target.closest('[data-np-protect]');
      if (!sw) return;
      e.preventDefault();
      if (sw.getAttribute('aria-busy') === 'true') return;
      const wasOn = sw.getAttribute('aria-checked') === 'true';
      sw.setAttribute('aria-busy', 'true');
      sw.setAttribute('aria-checked', String(!wasOn));
      sw.closest('.np-protect')?.classList.toggle('is-on', !wasOn);
      try {
        let data;
        if (wasOn) {
          if (!sw.dataset.lineKey) throw new Error('No protection line to remove');
          data = await postJSON(`${window.routes.cart_change_url}.js`, { id: sw.dataset.lineKey, quantity: 0, sections: SECTIONS });
        } else {
          const added = await postJSON(`${window.routes.cart_add_url}.js`, {
            items: [{ id: Number(sw.dataset.variantId), quantity: 1 }],
            sections: SECTIONS,
          });
          data = { sections: added.sections, item_count: 1 };
        }
        render(data);
        document.querySelector('[data-np-protect]')?.focus({ preventScroll: true });
      } catch (err) {
        console.error(err);
        sw.setAttribute('aria-checked', String(wasOn));
        sw.closest('.np-protect')?.classList.toggle('is-on', wasOn);
        sw.removeAttribute('aria-busy');
      }
    });
  }

  function initItemsIn() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let open = drawer.classList.contains('active');
    let timer = null;
    new MutationObserver(() => {
      const now = drawer.classList.contains('active');
      if (now && !open) {
        drawer.classList.add('np-items-in');
        clearTimeout(timer);
        timer = setTimeout(() => drawer.classList.remove('np-items-in'), ITEMS_IN_MS);
      }
      open = now;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  const start = () => { initCartAdds(); initProtection(); initItemsIn(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
